// Raid session windows, as availability-bit ranges.
//
// A player's availability is a 336-bit string covering one lockout week in
// half-hour slots. To ask "can this person make this raid", the raid's sessions
// have to be projected onto that same bit grid first. That projection is what
// this does.
//
// It lived inside PlannerPage until the mobile roster editor needed the exact
// same answer. Two copies would be two different definitions of "available",
// which is the sort of drift that quietly seats someone who cannot come.
import { getSessionWindows } from "../heuristic_roster";
import { getCurrentResetWeek, getResetWeekForDate } from "./time";

/**
 * Bit ranges covering every session of `raid`, or null when the raid has no
 * sessions yet.
 *
 * Null is meaningful: isCharacterAvailable() treats "no windows" as
 * "everyone is available" rather than "nobody is", because a raid without a
 * scheduled time cannot exclude anyone on time grounds.
 */
export function sessionWindowsForRaid(
  raid: { sessions?: any[]; anchorDate?: Date | string },
  userTz: string,
): [number, number][] | null {
  if (!raid?.sessions?.length) return null;
  const first = raid.sessions[0]?.starts_at;
  const anchor =
    raid.anchorDate != null
      ? raid.anchorDate instanceof Date
        ? raid.anchorDate
        : new Date(raid.anchorDate)
      : null;
  const weekStartIso =
    first != null
      ? getResetWeekForDate(new Date(first))
      : anchor != null && !Number.isNaN(anchor.getTime())
        ? getResetWeekForDate(anchor)
        : getCurrentResetWeek();
  return getSessionWindows(
    raid.sessions.map((s: any) => ({ startsAt: s.starts_at, durationMinutes: s.duration ?? 180 })),
    weekStartIso,
    userTz,
  );
}
